import React from "react";
import { Marker } from "react-map-gl";

import { toCurrency } from "../../../utils/currency";

import * as styles from "./styles.module.scss";

const LodgingMarker = ({ marker, id, setSelectedLodging, selected }: any) => {
  const { amount = "0.00", currency } = marker.price || {};
  const anchorClick = () => {
    setSelectedLodging(id);
  };

  return (
    <Marker
      key={`marker-${marker.index}`}
      longitude={marker.longitude}
      latitude={marker.latitude}
      className={selected ? "z-50" : ""}
    >
      <button
        className={`${styles.lodgingMarkerButton} ${
          selected ? styles.selected : ""
        }`}
        onClick={anchorClick}
      >
        <div className={styles.lodgingMarker}>
          {toCurrency({
            value: amount,
            valueCurrency: currency
          })}
          <div className={styles.arrowDownWrapper}>
            <div className={styles.arrowDown} />
          </div>
        </div>
      </button>
    </Marker>
  );
};

export default LodgingMarker;
